import React, { useEffect } from 'react';
import ReddyLayout from '../components/home/ReddyLayout';
import { useReddyAuth } from '../components/home/ReddyAuth';

const COLS = ['No', 'Event Name', 'Nation', 'Event Type', 'Market Name', 'Side', 'Rate', 'Amount', 'Place Date', 'Match Date'];
const stop = (e) => e.preventDefault();

/* Unsettled Bets (/reports/unsettled-bets) — post-login table page, same shell as
   Account Statement. Empty ("No Data Found") for a fresh account, exactly as the
   reference. Reuses the scoped userscreen-title / datatable / pagination-circle CSS. */
export default function UnsettledBetsPage() {
  const { user, login } = useReddyAuth();
  useEffect(() => { if (!user) login(); }, [user, login]);

  return (
    <ReddyLayout>
      <section className="section accounts">
        <div className="row">
          <div className="col-xl-12">
            <h2 className="userscreen-title">Unsettled Bets</h2>

            <div className="table-responsive">
              <table id="btDataTable" className="datatable table table-striped table-bordered" style={{ width: '100%' }}>
                <thead>
                  <tr>{COLS.map((c) => <th key={c}>{c}</th>)}</tr>
                </thead>
                <tbody>
                  <tr><td colSpan={COLS.length} className="noData">No Data Found</td></tr>
                </tbody>
              </table>

              <div className="pagination">
                <nav aria-label="pagination" className="Pager1">
                  <ul className="pagination pagination-circle justify-content-center">
                    <li className="page-item disabled"><a href="javascript:void(0)" className="page-link" onClick={stop}>« Previous</a></li>
                    <li className="page-item active"><a href="javascript:void(0)" className="page-link" onClick={stop}>1</a></li>
                    <li className="page-item disabled"><a href="javascript:void(0)" className="page-link" onClick={stop}>Next »</a></li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
    </ReddyLayout>
  );
}
